import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import TournamentNavigator from "../../../navigation/TournamentNavigator";
import styles from "./tournamentSettings.module.css";

const TournamentSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("tournaments", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/tournaments/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <TournamentNavigator />
    </div>
  );
};

export default TournamentSettings;
